import { rawTimeZones } from "@vvo/tzdb";

export const getWeeksInMonth = (year: number, month: number) => {
  const weeks: number[][] = [],
    firstDate = new Date(year, month, 1),
    lastDate = new Date(year, month + 1, 0),
    numDays = lastDate.getDate();

  let dayOfWeekCounter = firstDate.getDay();

  for (let date = 1; date <= numDays; date++) {
    if (dayOfWeekCounter === 0 || weeks.length === 0) {
      weeks.push([]);
    }
    weeks[weeks.length - 1].push(date);
    dayOfWeekCounter = (dayOfWeekCounter + 1) % 7;
  }

  return weeks
    .filter((w) => !!w.length)
    .map((w) => ({
      start: w[0],
      end: w[w.length - 1],
      dates: w,
    }));
};

const USED_TZS = [
  "US/Hawaii",
  "US/Alaska",
  "US/Pacific",
  "US/Mountain",
  "US/Central",
  "US/Eastern",
  "US/Arizona",
];

export const getUsedTzs = () => {
  const usedTzs = rawTimeZones.filter((tz) => {
    return tz.group.find((g) => USED_TZS.includes(g));
  });
  const remapped = usedTzs.map((tz) => ({
    ...tz,
    name: USED_TZS.find((t) => tz.group.includes(t)) ?? tz.name,
  }));
  return remapped;
};

export const getDefaultTz = (tz: string) => {
  const selected = rawTimeZones.find((t) => t.group.includes(tz));
  const tzs = getUsedTzs();
  const defaultTz =
    tzs.find((t) =>
      selected?.name.includes("America/Phoenix")
        ? t.name === "US/Arizona"
        : t.alternativeName === selected?.alternativeName,
    ) ?? tzs[0];

  return defaultTz;
};
